module.exports = __webpack_public_path__ + "img/sprite1.c80ff250.svg";